module.exports = __webpack_public_path__ + "10692080372b89795ea27e5efcfb9bf5.png";